<section class="w-full flex flex-col gap-2">
    @if (availableTemplates(); as templates) { @if (templates.length) {
    <section class="grid grid-cols-2 sm:grid-cols-3 gap-4 p-6">
        @for (template of templates; track template.id) {
        <button
            type="button"
            (click)="selectedTemplate(template.data)"
            class="group flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white text-left transition hover:border-blue-500 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500">
            <div class="aspect-video w-full overflow-hidden bg-gray-100">
                <img
                    [src]="template.thumbnailUrl"
                    [alt]="template.name"
                    loading="lazy"
                    class="h-full w-full object-cover transition duration-200 group-hover:scale-105" />
            </div>
            <div class="p-3">
                <p class="truncate font-medium text-gray-700">{{ template.name }}</p>
            </div>
        </button>
        }
    </section>
    } @else {
    <section class="w-full p-8 flex justify-center items-center">
        <p class="text-gray-500">{{ 'NO_TEMPLATES_AVAILABLE' | translate }}</p>
    </section>
    } }
</section>
